import { appApi } from "./api.service";
import { Preferences } from "@capacitor/preferences";

export interface RealtimeTokenResponse {
    hubUrl: string;
    token: string;
    topics: string[];
}

export const getRealtimeToken = async (): Promise<RealtimeTokenResponse> => {
    let profileId = await Preferences.get({'key': 'profile_id'});

    const response = await appApi.get('realtime/token?profileId=' + profileId.value, {
        headers: { 'No-Loader': true }
    });

    return response.data;
};
